import React from 'react';

function Terms() {
  return (
    <div className="py-20 px-6 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black text-primary mb-6">Terms of Service</h1>
          <p className="text-slate-600">Last updated: December 2024</p>
        </div>

        <div className="bg-white p-12 rounded-2xl shadow-sm border border-slate-200 prose prose-slate max-w-none">
          <h2 className="text-2xl font-bold text-primary mb-4">1. Acceptance of Terms</h2>
          <p className="text-slate-600 mb-6">
            By accessing and using Scope Order ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use the Service.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">2. Description of Service</h2>
          <p className="text-slate-600 mb-6">
            Scope Order provides a mobile application and web platform for contractors to create, manage, and send change order documentation to clients. The Service includes features such as digital signature capture, PDF generation, and email delivery.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">3. User Accounts</h2>
          <p className="text-slate-600 mb-4">
            You are responsible for:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized use</li>
            <li>Ensuring your account information is accurate and current</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mb-4">4. Subscription and Billing</h2>
          <p className="text-slate-600 mb-4">
            Scope Order Pro membership costs $19/month and includes:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
            <li>Unlimited change orders, clients, and jobs</li>
            <li>All features including signature capture and PDF generation</li>
            <li>Priority customer support</li>
          </ul>
          <p className="text-slate-600 mb-6">
            Subscriptions automatically renew unless canceled before the renewal date. You may cancel anytime from your account settings.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">5. User Content</h2>
          <p className="text-slate-600 mb-6">
            You retain all rights to the content you create using the Service, including change orders, client information, and signatures. By using the Service, you grant us permission to store and process this content to provide the Service to you.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">6. Acceptable Use</h2>
          <p className="text-slate-600 mb-4">
            You agree not to:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Use the Service for any illegal purpose</li>
            <li>Violate any laws or regulations</li>
            <li>Infringe on intellectual property rights</li>
            <li>Transmit malicious code or viruses</li>
            <li>Attempt to gain unauthorized access to the Service</li>
            <li>Use the Service to send spam or unsolicited communications</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mb-4">7. Service Availability</h2>
          <p className="text-slate-600 mb-6">
            While we strive to provide reliable service, we do not guarantee that the Service will be available at all times. We may suspend or terminate the Service for maintenance, updates, or other reasons without prior notice.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">8. Limitation of Liability</h2>
          <p className="text-slate-600 mb-6">
            The Service is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the Service, including but not limited to lost profits, data loss, or business interruption.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">9. Termination</h2>
          <p className="text-slate-600 mb-6">
            We reserve the right to suspend or terminate your access to the Service at any time for violation of these terms or for any other reason. Upon termination, you may export your data but will lose access to the Service.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">10. Changes to Terms</h2>
          <p className="text-slate-600 mb-6">
            We may modify these terms at any time. We will notify you of significant changes via email or through the Service. Continued use of the Service after changes constitutes acceptance of the modified terms.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">11. Contact Information</h2>
          <p className="text-slate-600">
            For questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:legal@scopeorder.com" className="text-secondary hover:underline">legal@scopeorder.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
